import { isOrganizationViewer } from 'util/organizationAccess';
import { faFolder, faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import {
  faFile,
  faToolbox,
  faArchive,
  faHistory,
  faUsers,
  faUserTie,
  faHandHoldingUsd
} from '@fortawesome/free-solid-svg-icons';
import {
  faAddressBook,
  faCreditCard,
  faFileContract,
  faFileInvoiceDollar
} from '@fortawesome/free-solid-svg-icons';
import c from 'util/const';
import config from 'util/config';

export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Dashboard',
      active: true,
      icon: 'chart-pie',
      to: '/',
      exact: true,
      active: true
    }
  ]
};

export const notaryRoutes = {
  label: 'The Notary eJournal',
  children: [
    {
      name: 'Journal',
      icon: 'book',
      to: '/notary/journal',
      active: true
    },
    {
      name: 'Journal Exports',
      icon: 'list',
      to: '/notary/reporting',
      active: true
    },
    {
      name: 'Saved Drafts',
      icon: faFolder,
      to: '/notary/drafts',
      active: true
    },
    {
      name: 'New Entry',
      icon: 'plus',
      to: '/notary/signing',
      active: true
    },
    {
      name: 'Practice Module',
      icon: faFile,
      // to: '/library/practice-module',
      to: '/notary/signing/practice-module',
      active: true
    }
  ]
};

export const libraryRoutes = {
  label: 'Briefcase',
  children: [
    {
      name: 'Document Types',
      icon: faFileContract,
      to: '/library/document-types',
      active: true
    },
    {
      name: 'Favorite Locations',
      icon: 'star',
      to: '/library/favorite-locations',
      active: true
    },
    {
      name: 'Signing Packages',
      icon: faFolderOpen,
      to: '/library/signing-packages',
      active: true
    },
    {
      name: 'My Clients',
      icon: faUsers,
      to: '/library/master-client',
      active: true,
      children: [
        {
          name: 'Client List',
          icon: faToolbox,
          to: '/library/master-client',
          active: true
        },
        {
          name: 'Archived Clients',
          icon: faArchive,
          to: '/library/master-client/archived',
          active: true
        }
      ]
    }
  ]
};

export const accountRoutes = {
  label: 'Account',
  children: [
    {
      name: 'User Profile',
      icon: 'user',
      to: '/account/user-profile',
      active: true
    },
    {
      name: 'Notary Commission',
      icon: 'user-circle',
      to: '/account/notary-profile',
      active: true
    },
    {
      name: 'Verification',
      icon: 'check',
      to: '/account/verification',
      active: true
    },
    {
      name: 'Devices',
      icon: 'mobile',
      to: '/account/devices',
      active: true
    },
    {
      name: 'Association',
      icon: 'users',
      to: '/account/associations',
      active: true
    }
  ]
};

export const knowledgeRoutes = {
  label: 'Knowledge Center',
  children: [
    {
      name: 'FAQs',
      icon: 'info-circle',
      to: '/knowledge-center/faqs',
      active: true
    },
    ...(config.notaryGptEnabled
      ? [
          {
            name: 'NotaryGPT',
            icon: 'comments',
            to: '/knowledge-center/notarygpt',
            active: true,
            badge: {
              type: 'success',
              text: 'New'
            }
          }
        ]
      : []),
    {
      name: 'Tutorials',
      icon: 'play',
      target: '_blank',
      to: 'https://intercom.help/jurat-inc/en',
      active: true
    }
  ]
};

export const extraRoutes = {
  label: 'Extras',
  children: [
    {
      name: 'Affiliate Program',
      icon: 'link',
      to: '/extra/affiliate-program',
      active: true
    },
    {
      name: 'Badges',
      icon: 'award',
      to: '/extra/badges',
      active: true
    },
    {
      name: 'Feature Requests',
      icon: 'layer-group',
      to: '/extra/feature-request',
      active: true
    }
  ]
};

export const billingRoutes = {
  label: 'Billing',
  children: [
    {
      name: 'Subscriptions',
      icon: 'crown',
      to: '/billing/subscriptions',
      active: true
    },
    {
      name: 'Payment History',
      icon: 'paper-plane',
      to: '/billing/payment-history',
      active: true
    },
    {
      name: 'Payment Methods',
      icon: faCreditCard,
      to: '/billing/payment-method',
      active: true
    }
  ]
};

export const adminRoutes = {
  label: 'Management',
  children: [
    {
      name: 'Dashboard',
      icon: 'chart-pie',
      to: '/admin',
      exact: true,
      active: true
    },
    {
      name: 'Location',
      icon: 'map-marker-alt',
      to: '/admin/location',
      active: true
    },
    {
      name: 'Connection Requests',
      icon: 'link',
      to: '/admin/connection-requests',
      active: true
    },
    {
      name: 'Notaries',
      icon: faUserTie,
      to: '/admin/notaries',
      activeExclude: ['^/admin/notaries/[^/]+/entries'],
      active: true
    },
    {
      name: 'Notary Journals',
      icon: 'book',
      to: '/admin/entries',
      activeMatch: ['^/admin/notaries/[^/]+/entries'],
      active: true
    },
    {
      name: 'Users',
      icon: faUsers,
      to: '/admin/users',
      active: true
    }
  ]
};

export const adminBillingRoutes = {
  label: 'Billing',
  children: [
    {
      name: 'Hosted Accounts',
      icon: faAddressBook,
      to: '/organization/billing/hosted-accounts',
      active: true
    },
    {
      name: 'Sponsorships',
      icon: faHandHoldingUsd,
      to: '/organization/billing/sponsorships',
      active: true
    },
    {
      name: 'Invoices',
      icon: faFileInvoiceDollar,
      to: '/organization/billing/invoices',
      active: true
    },
    {
      name: 'Payment Methods',
      icon: faCreditCard,
      to: '/organization/billing/payment-methods',
      exact: true,
      active: true
    },
    {
      name: 'Billing Audit',
      icon: faHistory,
      to: '/organization/billing/audit',
      active: true
    }
  ]
};

const allRoutes = [
  dashboardRoutes,
  notaryRoutes,
  libraryRoutes,
  accountRoutes,
  knowledgeRoutes,
  extraRoutes,
  billingRoutes
];

export function getRoutesForRoles(userRoles) {
  const roles = Array.isArray(userRoles) ? userRoles : [];
  const isAdmin =
    roles.includes(c.roles.TENANT_ADMIN) ||
    roles.includes(c.roles.SYSTEM_ADMIN);
  if (isAdmin) return [adminRoutes, adminBillingRoutes];
  if (isOrganizationViewer(roles))
    return [
      {
        ...adminRoutes,
        children: adminRoutes.children.filter(
          route => route.to !== '/admin/users'
        )
      }
    ];
  const hasAnyRole = roles.length > 0;
  return allRoutes.filter(route => {
    if (route.roles === undefined || route.roles === null) return true;
    if (!hasAnyRole) return false;
    return route.roles.some(r => roles.includes(r));
  });
}

export default [...allRoutes, adminRoutes, adminBillingRoutes];
